"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onboardingHeroCopy = void 0;
/** Shared right-rail hero copy for onboarding screens. */
exports.onboardingHeroCopy = {
    header: 'Now on Redo: Order Tracking',
    subHeader: 'Build branded tracking pages and transactional emails in minutes. Same post-purchase experience merchants loved in Malomo, now part of Redo.'
};
